import { render, staticRenderFns } from "./GrantSearchEntry.vue?vue&type=template&id=66faf601&scoped=true&"
import script from "./GrantSearchEntry.vue?vue&type=script&lang=js&"
export * from "./GrantSearchEntry.vue?vue&type=script&lang=js&"
import style0 from "./GrantSearchEntry.vue?vue&type=style&index=0&id=66faf601&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66faf601",
  null
  
)

export default component.exports